import React, {memo, useEffect} from "react";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
import Summary from "../components/summary";
import Systems from "../components/systems";
import Framework from "../components/framework";

import FrameworkPanel from "../components/framework_panel";
import IntroContent from "../text/intro.mdx";
import Acknowledgements from "../text/acknowledgments.mdx";
import cset_logo from "../images/cset_logo.svg";
import "../styles/styles.css";
import {MDXProvider} from "@mdx-js/react";

const IndexPage = () => {
  useEffect(() => {
    document.title = "Classifying AI Systems";
    document.documentElement.lang = "en";
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize();
  }, []);

  const [simplify, setSimplify] = React.useState(true);
  const handleWindowResize = () => {
    setSimplify(window.innerWidth < 680)
  };
  let tabs = [
    {
      "label": "Takeaways",
      "content": <Summary/>
    },
    {
      "label": "AI System Descriptions",
      "content": <Systems/>
    }
  ];
  tabs = tabs.concat(["A", "B", "C", "D"].map((fmwk_id) => (
    {
      "label": "Framework "+fmwk_id,
      "content": <Framework frameworkId={fmwk_id}/>
    }
  )));
  const components = {
    p: (() => {
      return memo(props =>
        <Typography {...props} component="p" variant="body1" style={{marginBottom: "20px"}}/>);
    })(),
    a: (() => {
      return memo(props =>
        <Link {...props} target={"_blank"} rel={"noopener"} component="a"/>);
    })()
  };

  return (
    <div>
      <div style={{backgroundColor: "#F9F9F9"}}>
        <div id="toolbar" style={{"padding": "20px"}}>
          <a href={"https://cset.georgetown.edu"} target="_blank" rel="noreferrer"
             title="Link to CSET website, cset.georgetown.edu">
            <img src={cset_logo} style={{"width": "300px"}} alt="CSET Logo"/>
          </a>
          <Button variant="contained"
                  color="primary"
                  style={{"float": "right"}}
                  href="https://docs.google.com/forms/d/e/1FAIpQLSf-Hgi4NrsZu3K_lKrp6Jx4jXPeVj5U0o-FcHYYHhf7pQnenQ/viewform?usp=sf_link"
                  target="_blank"
                  rel="noopener">
            Questions and Comments
          </Button>
        </div>
        <div id="project-description" style={{margin: "0px auto", width: "80%", maxWidth: "1540px", padding: "30px 20px 35px 20px"}}>
          <div id="description-header" style={{"marginBottom": "30px"}}>
            <Typography variant={"h4"} gutterBottom>Classifying AI Systems</Typography>
            <Typography variant={"h6"} gutterBottom>
              By <Link target="_blank" rel="noopener" style={{color: "black"}}
                       href={"https://cset.georgetown.edu/staff/catherine-aiken/"}>Catherine Aiken</Link> and Brian Dunn
            </Typography>
            <Typography variant={"subtitle2"}>
              Web development by <Link target="_blank" rel="noopener" style={{color: "black"}}
                                       href={"https://cset.georgetown.edu/staff/jennifer-melot/"}>
              Jennifer Melot</Link>
            </Typography>
          </div>
          <MDXProvider components={components}>
            <IntroContent/>
          </MDXProvider>
          <div style={{textAlign: "center", margin: "30px 0px 30px 0px"}}>
            <Button variant="contained" color="primary"
                    href={"https://georgetown.az1.qualtrics.com/jfe/form/SV_eXlLSjgJC6CVPH8"}
                    target="_blank" rel="noopener">Take the Survey</Button>
          </div>
          <Typography variant={"body2"} paragraph>
            <Acknowledgements/>
          </Typography>
        </div>
      </div>
      <div>
       <FrameworkPanel tabs={tabs} simplify={simplify}/>
      </div>
    </div>
  )
};

export default IndexPage;
